import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useUI } from "@/context/UIContext";
import { useLang } from "@/context/LanguageContext";
import { formatTRY } from "@/lib/format";

export function CartBar() {
  const { count, subtotal } = useCart();
  const { openCart, cartOpen } = useUI();
  const { t } = useLang();

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-30 mx-auto max-w-md">
      <div className="relative" style={{ height: 0 }}>
        <AnimatePresence>
          {count > 0 && !cartOpen && (
            <motion.button
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 24 }}
              transition={{ type: "spring", damping: 26, stiffness: 320 }}
              onClick={openCart}
              className="pointer-events-auto absolute inset-x-4 bottom-[84px] flex items-center justify-between rounded-full brand-gradient px-5 py-3.5 text-white shadow-float active:scale-[0.98]"
              data-testid="cart-bar"
            >
              <span className="flex items-center gap-2.5">
                <span className="relative">
                  <ShoppingBag className="h-5 w-5" />
                  <span className="absolute -end-2 -top-2 grid h-5 min-w-[20px] place-items-center rounded-full bg-white px-1 text-[11px] font-extrabold text-primary">
                    {count}
                  </span>
                </span>
                <span className="font-heading text-[15px] font-bold">{t("viewCart")}</span>
              </span>
              <span className="font-heading text-base font-extrabold">{formatTRY(subtotal)}</span>
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
